import { isExtension } from "utilities/src/platform";
export function getChrome() {
  if (typeof chrome !== "undefined") {
    return chrome;
  }
  warnIfChromeIsAccessedInContentScript();
  return void 0;
}
export function getChromeWithThrow() {
  if (typeof chrome !== "undefined") {
    return chrome;
  }
  warnIfChromeIsAccessedInContentScript();
  throw new Error("`chrome` is not available in this context");
}
export function getChromeRuntime() {
  if (typeof chrome !== "undefined" && chrome.runtime) {
    return chrome.runtime;
  }
  warnIfChromeIsAccessedInContentScript();
  return void 0;
}
export function getChromeRuntimeWithThrow() {
  if (typeof chrome !== "undefined" && chrome.runtime) {
    return chrome.runtime;
  }
  warnIfChromeIsAccessedInContentScript();
  throw new Error("`chrome.runtime` is not available in this context");
}
function warnIfChromeIsAccessedInContentScript() {
  if (isExtension) {
    console.warn(
      "You are trying to access `chrome.runtime` inside the injected content script even though it does not exist in this context. `chrome.runtime` is only available in the injected script when it is running inside a trusted site (`app.ring.exchange`), so this could have unintended consequences and should be avoided."
    );
  }
}
